import Vue from 'src/views/base'
import Component from 'vue-class-component'

@Component({
    name: 'app',
    props: {},
    components: {
    }
})
export default class App extends Vue {
}



// WEBPACK FOOTER //
// ./src/views/app/app.js